/**
 * InfinitSales - Platform Health Service
 *
 * API client do Painel de Plataforma (saúde multi-cliente, só o dono).
 * Backend: GET /api/platform/health.
 *
 * O backend cacheia o retrato por 60s porque as checagens batem na Meta e na
 * Evolution. O painel respeita esse ritmo: pedir mais rápido não traz dado mais
 * novo, só devolve o mesmo cache. `refresh` força uma coleta nova e existe para
 * o botão "Atualizar agora", não para o ciclo automático.
 */
import api from './api';

const platformHealthService = {
  /**
   * Retrato agregado por cliente, pior primeiro, plataforma por último.
   * @param {boolean} refresh - ignora o cache do backend e recoleta.
   * Retorna { gerado_em, nivel_geral, totais, clientes[], cache_idade_s }.
   */
  async getHealth(refresh = false) {
    const res = await api.get(`/api/platform/health${refresh ? '?refresh=true' : ''}`);
    return res.data?.data;
  },

  /**
   * Saúde das conexões DO PRÓPRIO usuário, para o diagnóstico dentro do modal
   * de conexão. Sem gate de dono da plataforma: o escopo é quem pergunta, e o
   * backend resolve as contas pelo user_id do token (não há como apontar para
   * o workspace de outro cliente).
   * @param {string|null} canal - wa_business | wa_personal | instagram | messenger
   * @param {boolean} refresh - ignora o cache do backend e recoleta agora.
   */
  async getMinhaConexao(canal = null, refresh = false) {
    const params = new URLSearchParams();
    if (canal) params.set('canal', canal);
    if (refresh) params.set('refresh', 'true');
    const qs = params.toString();
    const res = await api.get(`/api/platform/health/minha-conexao${qs ? `?${qs}` : ''}`);
    return res.data?.data;
  },

  /**
   * Se o usuário atual enxerga o painel. Usado para decidir se a aba aparece.
   * Nunca devolve a lista de donos, só um booleano sobre quem perguntou.
   */
  async temAcesso() {
    try {
      const res = await api.get('/api/platform/health/acesso');
      return Boolean(res.data?.data?.dono_da_plataforma);
    } catch {
      // 401/403/404 e falha de rede caem aqui: na dúvida, a aba não aparece.
      return false;
    }
  },
};

export default platformHealthService;
